import React from "react";
import { Tabs, Tab, Box, Card, CardContent } from "@mui/material";
import { useStickyTab } from "../../../utils/uiPrefs";
// ✅ Fix: import the actual parameters dashboard component
import FoamParametersDashboard from "./FoamParametersDashboard";
import FoamBlenders from "./FoamBlenders";
import FoamWinderStatus from "../../common/FoamWinderStatus";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  // ✅ Don’t render the other tab at all (avoids heavy work & effects running)
  if (value !== index) return null;
  return (
    <div
      role="tabpanel"
      id={`foam-tabpanel-${index}`}
      aria-labelledby={`foam-tab-${index}`}
      style={{ width: "100%" }}
    >
      <Box sx={{ pt: { xs: 1, md: 2 } }}>{children}</Box>
    </div>
  );
};

const a11yProps = (index: number) => ({
  id: `foam-tab-${index}`,
  "aria-controls": `foam-tabpanel-${index}`,
});

const FoamProductionTabs: React.FC = () => {
  // Only tabs 0–1 have panels ("Tuning" is a placeholder), so don't restore 2.
  const [tab, setTab] = useStickyTab("foam", 2);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Card sx={{ m: { xs: 1, md: 2 } }}>
      <CardContent sx={{ p: { xs: 1, md: 2 } }}>
        {/* Above the tabs: winder state is worth seeing whichever tab is open. */}
        <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
          <FoamWinderStatus />
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="Foam production tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              label="Parameters"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
              {...a11yProps(0)}
            />
            <Tab
              label="Blenders"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
              {...a11yProps(1)}
            />
            <Tab
              label="Tuning"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>

        <TabPanel value={tab} index={0}>
          <FoamParametersDashboard />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <FoamBlenders />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default FoamProductionTabs;
